import type { RcFile }         from 'antd/es/upload';
import { Steps }               from 'antd';
import { Button }              from 'antd';
import { message }             from 'antd';
import { withNavigation }      from 'components/App/withNavigation';
import { WithNavigationProps } from 'components/App/withNavigation';
import YesOrNo                 from 'components/App/YesOrNo';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import StandImportFileModel    from 'models/StandImportFileModel';
import StandImportModel        from 'models/StandImportModel';
import StandImportFile         from 'models/StandImportFileModel';
import React                   from 'react';
import { Upload }              from 'antd';
import ShowModel               from 'models/ShowModel';
import { messageErrorIntl }    from 'utils/messageIntl';

const Step1 = ({
  beforeUpload,
  list,
  onRemove,
}: {
  beforeUpload: (file: RcFile, listName: string, fileName: string) => void;
  list: RcFile[];
  onRemove: (file: RcFile, listName: string, fileName: string) => void;
}) => (
  <div>
    <br />
    <p>Fichier CSV :</p>
    <Upload
      beforeUpload={file => {
        beforeUpload(file, 'logoList', 'logo');
        return false;
      }}
      defaultFileList={list}
      fileList={list}
      onRemove={(file: any) => onRemove(file, 'logoList', 'logo')}
    >
      <Button htmlType="button">
        <FormattedMessageWrapper id="Parcourir..." />
      </Button>
    </Upload>
    <br />
  </div>
);

const Step2 = ({
  analysing,
  standImport,
  violations
}: {
  analysing: boolean;
  standImport?: StandImportModel;
  violations: any[];
}) => (
  <div>
    <br />
    {analysing && (
      <p>
        <FormattedMessageWrapper id="Analyse en cours..." />
      </p>
    )}
    {(standImport && !violations.length) && (
      <>
        <p>
          <FormattedMessageWrapper id="Voici le résultat de l'analyse de votre fichier :" />
        </p>
        <p style={{ color: '#27ae60' }}>
          <FormattedMessageWrapper
            id="{created} stand(s) seront créés, {updated} stand(s) seront mis à jour"
            values={{
              created: standImport.stats.stands.created,
              updated: standImport.stats.stands.updated,
            }}
          />
        </p>
        <p style={{ color: '#27ae60' }}>
          <FormattedMessageWrapper
            id="{new} exposant(s) seront créés, {updated} exposant(s) seront mis à jour"
            values={{
              new: standImport.stats.exhibitors.new,
              updated: standImport.stats.exhibitors.updated,
            }}
          />
        </p>
        <p style={{ color: '#27ae60' }}>
          <FormattedMessageWrapper
            id="{new} décorateur(s) seront créés, {updated} décorateur(s) seront mis à jour"
            values={{
              new: standImport.stats.decorators.new,
              updated: standImport.stats.decorators.updated,
            }}
          />
        </p>
        <p style={{ color: '#27ae60' }}>
          <FormattedMessageWrapper
            id="{new} agence(s) seront créées, {updated} agence(s) seront mises à jour"
            values={{
              new: standImport.stats.agencies.new,
              updated: standImport.stats.agencies.updated,
            }}
          />
        </p>
      </>
    )}
    {violations && (
      <ul style={{ color: '#e74c3c' }}>
        {violations.map((violation, violationIndex) => (
          <li key={violationIndex}>
            {violation.propertyPath} : {violation.message}
          </li>
        ))}
      </ul>
    )}
  </div>
);

const Step3 = ({
  modifyNotifyUsers,
  notifyUsers
}: {
  modifyNotifyUsers: (event: any) => void;
  notifyUsers: boolean;
}) => (
  <div>
    <p>
      <FormattedMessageWrapper id="Souhaitez-vous notifier ces exposants pour demander les plans ?" />
    </p>
    <YesOrNo onChange={modifyNotifyUsers} value={notifyUsers} />
  </div>
);

interface StandImportStepsState {
  analysing: boolean;
  current: number;
  list: any[];
  notifyUsers: boolean;
  saveAllowed: boolean;
  standImport?: StandImportModel;
  standImportFile?: StandImportFile;
  step2allowed: boolean;
  step3allowed: boolean;
  violations: any[];
}

class StandImportSteps extends React.Component<WithNavigationProps> {
  state:StandImportStepsState = {
    analysing: false,
    current: 0,
    list: [],
    notifyUsers: true,
    saveAllowed: false,
    standImport: undefined,
    standImportFile: undefined,
    step2allowed: false,
    step3allowed: false,
    violations: [],
  };

  public beforeUpload = async (file: RcFile) => {
    this.setState({
      list: [file],
      // uploading: true,
    });

    const standImportFileModel = new StandImportFileModel();
    standImportFileModel.set('file', file);

    try {
      const response = await standImportFileModel.save() as any;

      this.setState({
        // uploading: false,
        standImportFile: response?.data['@id'],
        step2allowed: true,
        step3allowed: false,
      });
    } catch (error: any) {
      messageErrorIntl("Le chargement du fichier a échoué.");

      error.connectorError.response?.data.violations.forEach((violation: any) =>
        message.error(violation.message),
      );

      this.setState({
        // uploading: false,
        list: [],
      });
    }
  };

  public checkImport = async () => {
    const showIri = new ShowModel().path + this.props.params.showId;

    const standImportModel = new StandImportModel();
    standImportModel.set('standImportFile', this.state.standImportFile);
    standImportModel.set('show', showIri);

    try {
      const response = await standImportModel.save();

      this.setState({
        analysing: false,
        standImport: response.attributes,
        step2allowed: true,
        step3allowed: true,
        violations: [],
      });
    } catch (error: any) {
      const responseData = error.connectorError.response?.data;

      const violations = responseData?.violations
        ?? (responseData?.['hydra:description']
          ? [{ message: responseData['hydra:description'], propertyPath: 'file' }]
          : [{ message: <FormattedMessageWrapper id="Une erreur s'est produite." />, propertyPath: 'file' }]);

      if (!responseData?.violations && !responseData?.['hydra:description']) {
        messageErrorIntl("Une erreur s'est produite.");
      }

      this.setState({
        analysing: false,
        step2allowed: true,
        step3allowed: false,
        violations,
      });
    }
  };

  public isNextDisabled = () => {
    if (this.state.current === 0) {
      return !this.state.step2allowed;
    }
    if (this.state.current === 1) {
      return !this.state.step3allowed;
    }
    return true;
  };

  public next = () => {
    if (this.state.current === 0) {
      this.setState((prevState: StandImportStepsState) => ({
        analysing: true,
        current: prevState.current + 1,
      }), () => this.checkImport());
    } else {
      this.setState((prevState: StandImportStepsState) => ({
        current: prevState.current + 1,
      }));
    }
  };

  public onRemove = () => {
    this.setState({
      list: [],
      standImportFile: null,
      step2allowed: false,
      step3allowed: false,
    });
  };

  public prev = () => {
    this.setState((prevState: StandImportStepsState) => ({ current: prevState.current - 1 }));
  };

  public render() {
    const steps = [
      {
        additionalContent: (
          <Step1 beforeUpload={this.beforeUpload} list={this.state.list} onRemove={this.onRemove} />
        ),
        title: 'Fichier CSV',
      },
      {
        additionalContent: (
          <Step2
            analysing={this.state.analysing}
            standImport={this.state.standImport}
            violations={this.state.violations}
          />
        ),
        title: 'Vérification du contenu',
      },
      {
        additionalContent: (
          <Step3
            modifyNotifyUsers={event => {
              this.setState({ notifyUsers: event.target.value });
            }}
            notifyUsers={this.state.notifyUsers}
          />
        ),
        title: 'Confirmation',
      },
    ];

    const { current } = this.state;
    const nextDisabled = this.isNextDisabled();

    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
        }}
      >
        <Steps
          current={current}
          items={steps.map(item => ({ title: item.title }))}
        />
        <div
          className="steps-content"
          style={{
            alignItems: 'center',
            display: 'flex',
            flex: 1,
          }}
        >
          {steps[current].additionalContent}
        </div>
        <div className="steps-action">
          {current < steps.length - 1 && (
            <Button
              disabled={nextDisabled}
              htmlType="button"
              onClick={() => this.next()}
              style={{ float: 'right' }}
              type="primary"
            >
              Suivant
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              disabled={this.state.saveAllowed}
              htmlType="button"
              onClick={this.validateImport}
              style={{ float: 'right' }}
              type="primary"
            >
              <FormattedMessageWrapper id="Enregistrer" />
            </Button>
          )}
          {current > 0 && (
            <Button htmlType="button" onClick={() => this.prev()} style={{ marginLeft: 8 }}>
              <FormattedMessageWrapper id="Précédent" />
            </Button>
          )}
        </div>
      </div>
    );
  }

  public validateImport = async () => {
    const standImportModel = new StandImportModel();
    standImportModel.set('id', this.state.standImport?.id);
    standImportModel.set('status', 2);
    standImportModel.set('notifyUsers', this.state.notifyUsers);

    try {
      await standImportModel.save();

      this.props.navigate(`/salons/${this.props.params.showId}/stands`);
    } catch (error: any) {
      if (error.connectorError.response.status === 400) {
        message.error(error.connectorError.response?.data['hydra:description']);
      } else {
        messageErrorIntl("Une erreur s'est produite.");
      }
    }
  };
}

const WrappedStandImportSteps = withNavigation(StandImportSteps);

export default WrappedStandImportSteps;